import {
  List,
  Datagrid,
  TextField,
  SelectInput,
  DateInput,
  useListContext,
  ReferenceField,
  FunctionField,
} from 'react-admin'

import FilterComponent from '../../components/Filter'
import DateTimeField from '../../components/DateTimeField'

export const GIFT_TYPES = [
  { id: 'GIFTING_BOOK', name: 'Book' },
  { id: 'GIFTING_BOOK_V2', name: 'Book' },
  { id: 'GIFTING_ENGLISH_BOOK', name: 'English Book' },
  { id: 'GIFTING_ENGLISH_BOOK_V2', name: 'English Book' },
  { id: 'GIFTING_COURSE', name: 'Course' },
  { id: 'GIFTING_COURSE_V2', name: 'Course' },
]

const GiftingFilter = props => {
  const { filterValues } = useListContext()
  return (
    <FilterComponent {...props}>
      {/*<TextInput label="Search" source="name" alwaysOn />*/}
      <SelectInput
        source="productType"
        choices={GIFT_TYPES}
        alwaysOn
        allowEmpty={true}
      />
      <SelectInput
        label="Filter"
        source="date"
        choices={[
          { id: 'all', name: 'All' },
          { id: 'this_month', name: 'This month' },
          { id: 'last_month', name: 'Last month' },
          { id: 'custom', name: 'Choose date' },
        ]}
        alwaysOn
        allowEmpty={false}></SelectInput>
      {'custom' === filterValues.date && (
        <DateInput label="From date" source="fromDate" alwaysOn></DateInput>
      )}
      {'custom' === filterValues.date && (
        <DateInput label="To date" source="toDate" alwaysOn></DateInput>
      )}
    </FilterComponent>
  )
}

const GiftingDashboardList = props => (
  <List
    {...props}
    filters={<GiftingFilter />}
    sort={{ field: 'id', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <TextField source="id" />
      <DateTimeField source="createdAt" label="Date" />
      <TextField source="productType" />
      <FunctionField
        label="Content"
        render={record => {
          switch (record.productType) {
            case 'GIFTING_BOOK':
            case 'GIFTING_BOOK_V2':
              return (
                <ReferenceField reference="books" source="contentId">
                  <TextField source="title" />
                </ReferenceField>
              )
            case 'GIFTING_COURSE':
            case 'GIFTING_COURSE_V2':
              return (
                <ReferenceField reference="courses" source="contentId">
                  <TextField source="title" />
                </ReferenceField>
              )
            case 'GIFTING_ENGLISH_BOOK':
            case 'GIFTING_ENGLISH_BOOK_V2':
              return (
                <ReferenceField reference="english-books" source="contentId">
                  <TextField source="title" />
                </ReferenceField>
              )
            default:
              return 'N/A'
          }
        }}
      />
      <TextField source="recipientEmail" />
      <TextField source="recipientPhone" />
      <TextField source="recipientName" />
      <TextField source="senderName" />
      <ReferenceField
        reference="user-details"
        source="senderId"
        label="Sender ID">
        <TextField source="id" label="Sender ID" />
      </ReferenceField>
      <TextField source="giftMessage" />
      <TextField source="ccEmail" />
    </Datagrid>
  </List>
)

export default GiftingDashboardList
